import React from 'react';

const Profile2User = ({ size = 20, color = "#4A154B", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.63338 9.05841C7.55005 9.05008 7.45005 9.05008 7.35838 9.05841C5.37505 8.99175 3.80005 7.36675 3.80005 5.36675C3.80005 3.32508 5.45005 1.66675 7.50005 1.66675C9.54172 1.66675 11.2 3.32508 11.2 5.36675C11.1917 7.36675 9.61672 8.99175 7.63338 9.05841Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.675 3.33325C15.2916 3.33325 16.5916 4.64159 16.5916 6.24992C16.5916 7.82492 15.3417 9.10825 13.7833 9.16659C13.7167 9.15825 13.6417 9.15825 13.5667 9.16659"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.4666 12.1333C1.44993 13.4833 1.44993 15.6833 3.4666 17.0249C5.75827 18.5583 9.5166 18.5583 11.8083 17.0249C13.8249 15.6749 13.8249 13.4749 11.8083 12.1333C9.52494 10.6083 5.7666 10.6083 3.4666 12.1333Z"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2834 16.6667C15.8834 16.5417 16.4501 16.3001 16.9168 15.9417C18.2168 14.9667 18.2168 13.3584 16.9168 12.3834C16.4584 12.0334 15.9001 11.8001 15.3084 11.6667"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Profile2User;
